<template>
  <div class="mb-16">
    <CheckoutHeader :current-step="1" />
    <CheckoutLayout
      next-link="/checkout/seats"
      :title="$t('checkout.addons')"
      :has-discount-code="false"
      :has-gift-card="false"
    >
      <div class="space-y-4">
        <CheckoutAddon
          :ticket-id="cart.items[0].id"
          v-for="addon in addons"
          :key="addon.id"
          :addon="addon"
        />
      </div>
    </CheckoutLayout>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue';
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import CheckoutAddon from '@/components/checkout/CheckoutAddon.vue';
  import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
  import CheckoutLayout from '@/components/checkout/CheckoutLayout.vue';
  import { addonItems } from '@/data';
  import { useCartStore } from '@/stores/cart';

  const { t } = useI18n();

  const addons = ref(addonItems);

  const cart = useCartStore();

  useHead({
    title: t('checkout.addons'),
    meta: [
      {
        property: 'og:title',
        content: t('checkout.addons'),
      },
    ],
  });
</script>
